import * as React from 'react';
import type TranscriptTurnView from '@UI/Store/Interviews/Views/TranscriptTurnView';

export type AudioPlayerContextType = {
	readonly audioRef: React.RefObject<HTMLAudioElement | null>;
	readonly audioSrc: string | null;
	readonly isAvailable: boolean;
	readonly isPlaying: boolean;
	readonly currentTime: number;
	readonly duration: number;
	readonly isPositionable: boolean;
	readonly activeTurnId: number | null;
	readonly hasPlaybackExceededLoadedTurns: boolean;
	readonly playbackRate: number;
	readonly togglePlay: () => void;
	readonly seekToTurn: (turn: TranscriptTurnView) => void;
	/** Clamped to `[0, duration]`; a no-op while the recording is not positionable. */
	readonly seekTo: (seconds: number) => void;
	readonly skipBy: (deltaSeconds: number) => void;
	readonly cyclePlaybackRate: () => void;
};

const AudioPlayerContext = React.createContext<AudioPlayerContextType | null>(null);

export default AudioPlayerContext;
